<template>
    <div>
        <v-subheader>{{ $t('settings.firmao.title') }}</v-subheader>
        <v-form>
            <v-row>
                <v-col
                    cols="12"
                    xs="12"
                    md="4"
                    lg="3">
                    <v-text-field
                        type="text"
                        v-model="firmao.id"
                        @change="untested"
                        :label="$t('settings.firmao.id')">
                    </v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    xs="12"
                    md="4"
                    lg="3">
                    <v-text-field
                        type="text"
                        v-model="firmao.user"
                        @change="untested"
                        :label="$t('settings.firmao.user')">
                    </v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    xs="12"
                    md="4"
                    lg="3">
                    <v-text-field
                        type="password"
                        v-model="firmao.pass"
                        @change="untested"
                        :label="$t('settings.firmao.password')">
                    </v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    xs="12"
                    md="4"
                    lg="3">
                    <v-progress-circular v-if="testing" color="secondary" indeterminate></v-progress-circular>
                    <span v-if="!testing && tested">
                        <v-icon v-if="isCorrect" color="primary">mdi-check-circle-outline</v-icon>
                        <v-icon v-else color="red">mdi-alert-decagram-outline</v-icon>
                    </span>
                    <v-btn style="color: #fff" color="light-blue" @click="testConfig(false)">{{ $t('base.test') }}</v-btn>
                    <v-btn style="color: #fff" :disabled="!isCorrect" color="light-green" @click="updateConfig()">{{ $t('base.save') }}</v-btn>
                </v-col>
            </v-row>
        </v-form>
    </div>
</template>

<script>
    export default {
        name: "firmao",
        data() {
            return {
                testing: false,
                isCorrect: false,
                tested: false,
                alert: false,
                firmao: {
                    id: '',
                    user: '',
                    pass: ''
                }
            }
        },
        methods: {
            testConfig(existing = true) {
                this.testing = true
                let payload = (existing)
                    ? { method: 'GET', url: '/firmao/check' }
                    : { method: 'POST', url: '/firmao/test', data: { id: this.firmao.id, username: this.firmao.user, password: this.firmao.pass }}
                this.$http(payload)
                    .then(({data}) => {
                        this.isCorrect = data.result
                        this.testing = false
                        this.tested = true
                    })
                    .catch(() => {
                        this.untested()
                        this.tested = false
                    })
            },
            updateConfig() {
                this.testing = true
                this.$http.post('/firmao/config', { id: this.firmao.id, username: this.firmao.user, password: this.firmao.pass })
                    .then(() => {
                        this.testing = false
                    })
                    .catch(() => {
                        this.testing = false
                    })
            },
            untested() {
                this.tested = false
                this.isCorrect = false
            }
        },
        mounted() {
            this.testConfig()
        }
    }
</script>

<style scoped>

</style>
